// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"IN_News_Section1_contentSection__226S4","customContainer":"IN_News_Section1_customContainer__1nB6P","title":"IN_News_Section1_title__mAafH"};